import React from "react";

const SearchResultsIndicator = ({
  isSearching,
  statusFilter,
  searchTerm,
  onClearFilters,
  columnFilters,
  streetViewOnly,
  statusOrderRosOnly,
  activeView,
  isDarkMode,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1rem",
      }}
    >
      <h3 style={{ margin: 0, color: isDarkMode ? "#e2e8f0" : "#333" }}>
        {(isSearching ||
          statusFilter ||
          streetViewOnly ||
          statusOrderRosOnly) && (
          <span style={{ fontWeight: "normal" }}>
            {isSearching ? "Search Results " : "Filtered Results "}
            {searchTerm && (
              <>
                for:{" "}
                <strong style={{ fontWeight: "bold" }}>{searchTerm}</strong>
              </>
            )}
            {statusFilter && (
              <>
                with status:
                <strong style={{ fontWeight: "bold" }}>
                  {statusFilter?.split("-")[1] || statusFilter}{" "}
                </strong>
              </>
            )}
            {streetViewOnly && (
              <>
                {!statusFilter && !searchTerm ? "by" : "and"}{" "}
                <strong style={{ fontWeight: "bold" }}>Street View Only</strong>
              </>
            )}
            {statusOrderRosOnly && (
              <>
                {!statusFilter && !searchTerm && !streetViewOnly ? "by" : "and"}{" "}
                <strong style={{ fontWeight: "bold" }}>
                  Status Order ROS Only
                </strong>
              </>
            )}
          </span>
        )}
        {/* ➕ Date filter — simple append */}
        {columnFilters?.orderDate && (
          <>
            date "
            <strong>
              {columnFilters.orderDate?.type === "after"
                ? `after ${new Date(
                    columnFilters.orderDate.value1
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}`
                : columnFilters.orderDate?.type === "before"
                ? `before ${new Date(
                    columnFilters.orderDate.value1
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}`
                : columnFilters.orderDate?.type === "between"
                ? `between ${new Date(
                    columnFilters.orderDate.value1
                  ).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                  })} and ${new Date(
                    columnFilters.orderDate.value2
                  ).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}`
                : ""}
            </strong>
          </>
        )}
      </h3>
      {activeView !== "analytics" && activeView !== "accuzip" && (
        <button
          onClick={onClearFilters}
          style={{
            background: "none",
            border: `1px solid ${isDarkMode ? "#4a5568" : "#e1e5ee"}`,
            padding: "0.5rem 1rem",
            borderRadius: "4px",
            fontWeight: "500",
            cursor: "pointer",
            color: isDarkMode ? "#e1e5ee" : "#667eea",
            backgroundColor: isDarkMode ? "#2d3748" : "transparent",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor = isDarkMode
              ? "#303641ff"
              : "#667eea20")
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = isDarkMode
              ? "#2d3748"
              : "transparent")
          }
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default SearchResultsIndicator;
